/**
 * 対象日・対象期間の表示ラベル。
 * 期間ノートは「開始 〜 終了」で表す（docs/01-requirements.md §5.6）。
 */

import { formatJstDateLabel } from '@shared/date';
import type { JstDate } from '@shared/types';

export function subjectLabel(start: JstDate, end: JstDate | null): string {
  if (end && end !== start) {
    return `${formatJstDateLabel(start)} 〜 ${formatJstDateLabel(end)}`;
  }
  return formatJstDateLabel(start);
}
